import React from 'react';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend } from 'recharts';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

import './CadeAnalyze.css';

const CadeAnalyzeRadar = (props) => {
    if (props.domainConcerns.length == 0) {
        return null;
    }

    // Just using partner and clinician for now (all seems too cluttered)
    const domainData = props.domainConcerns.map((domainConcern) => {
        return {
            "subject": domainConcern.domainName,
            "A": domainConcern.clinicianConcernLevel,
            "B": domainConcern.partnerConcernLevel,
            "C": domainConcern.caregiverConcernLevel,
            "D": domainConcern.rater1ConcernLevel,
            "E": domainConcern.rater2ConcernLevel,
            "fullMark": 3
        }

    });

    let radarName = "Domain Concerns";
    let dataKey = "Z";
    let radarColor = "#000000";
    if (!isNullOrEmpty(props.cadeModeFor)) {
        switch (props.cadeModeFor) {
            case 1:
                dataKey = "A";
                radarColor = "#0000FF";
                break;

            case 2:
                dataKey = "B";
                radarColor = "#51ed12";
                break;

            case 3:
            case 6:
                dataKey = "C";
                radarColor = "#AD6452";
                break;

            case 4:
                dataKey = "D";
                radarColor = "#2FFD02";
                break;

            case 5:
                dataKey = "E";
                radarColor = "#2FE62E";
                break;

            default:
                // Can't happen
                break;
        }
    }

    return (
        <ResponsiveContainer height={550}>
            <RadarChart outerRadius={props.outerRadius} data={domainData} >
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" />
                <PolarRadiusAxis tick={false} axisLine={false} angle={30} fullMark={3} domain={[0, 3]} />
                <Radar name={radarName} dataKey={dataKey} stroke={radarColor} fill={radarColor} fillOpacity={0.6} />
                <Legend />
            </RadarChart>
        </ResponsiveContainer>
    );
}

export default CadeAnalyzeRadar;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeAnalyzeRadar.js